module.exports = __webpack_public_path__ + "img/comment-lines.54ed8156.svg";